import React from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import NewsList from 'app/components/district/news/NewsList';
import InfiniteScrollLoadingIndicator from 'app/components/district/InfiniteScrollLoadingIndicator';
import { fetchNewsList } from 'app/queries/districtNews';
import { useDispatch } from 'react-redux';
import InfiniteScrollErrorMessage from 'app/components/district/InfiniteScrollErrorMessage';
import SeoLinks from 'app/components/seo/SeoLinks';
import InfiniteScrollTrigger from 'app/components/infiniteScroll/InfiniteScrollTrigger';
export default function AllNews(_ref) {
  let {
    slug,
    initialData
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    isFetchingNextPage,
    refetch
  } = useInfiniteQuery({
    queryKey: ['districtNews', {
      slug
    }],
    queryFn: _ref2 => {
      let {
        pageParam = null
      } = _ref2;
      return fetchNewsList(slug, pageParam, dispatch);
    },
    getNextPageParam: lastPage => {
      if (lastPage.links.next) {
        return lastPage.links.next;
      }
      return undefined;
    },
    initialData: initialData ? {
      pages: [initialData],
      pageParams: [undefined]
    } : undefined
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(InfiniteScrollLoadingIndicator, null);
  }
  if (isError && !(data !== null && data !== void 0 && data.pages.length)) {
    return /*#__PURE__*/React.createElement(InfiniteScrollErrorMessage, {
      onRetry: refetch
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NewsList, {
    data: data,
    "data-sentry-element": "NewsList",
    "data-sentry-source-file": "AllNews.tsx"
  }), /*#__PURE__*/React.createElement(InfiniteScrollTrigger, {
    onTrigger: fetchNextPage,
    "data-sentry-element": "InfiniteScrollTrigger",
    "data-sentry-source-file": "AllNews.tsx"
  }), isFetchingNextPage ? /*#__PURE__*/React.createElement(InfiniteScrollLoadingIndicator, null) : isError ? /*#__PURE__*/React.createElement(InfiniteScrollErrorMessage, {
    onRetry: refetch
  }) : /*#__PURE__*/React.createElement(SeoLinks, {
    data: data.pages
  }));
}